const ROMAN_BASE_PRICE = 35.99;

const ROMAN_WIDTH_INCREMENTS = Object.freeze({
  20: 15,
  21: 15,
  22: 15,
  23: 15,
  24: 16,
  25: 17,
  26: 18,
  27: 20,
  28: 22,
  29: 25,
  30: 27,
  31: 31,
  32: 34,
  33: 36,
  34: 38,
  35: 41,
  36: 43,
  37: 46,
  38: 53,
  39: 56,
  40: 58,
  41: 60,
  42: 63,
  43: 65,
  44: 75,
  45: 78,
  46: 85,
  47: 88,
  48: 90,
  49: 92,
  50: 94,
  51: 96,
  52: 98,
  53: 100,
  54: 102,
  55: 104,
  56: 106,
  57: 108,
  58: 110,
  59: 112,
  60: 114,
  61: 116,
  62: 118,
  63: 120,
  64: 123,
  65: 122,
  66: 126,
  67: 128,
  68: 130,
  69: 133,
  70: 132,
  71: 136,
  72: 140,
  73: 143,
  74: 146,
  75: 152,
  76: 158,
  77: 160,
  78: 162,
  79: 164
});

const ROMAN_HEIGHT_INCREMENTS = Object.freeze({
  22: 19,
  23: 21,
  24: 21,
  25: 22,
  26: 22,
  27: 23,
  28: 23,
  29: 24,
  30: 24,
  31: 25,
  32: 25,
  33: 26,
  34: 26,
  35: 27,
  36: 28,
  37: 28,
  38: 28,
  39: 29,
  40: 29,
  41: 30,
  42: 30,
  43: 31,
  44: 31,
  45: 32,
  46: 32,
  47: 33,
  48: 33,
  49: 34,
  50: 34,
  51: 35,
  52: 35,
  53: 36,
  54: 36,
  55: 37,
  56: 37,
  57: 38,
  58: 38,
  59: 39,
  60: 39,
  61: 40,
  62: 40,
  63: 41,
  64: 41,
  65: 42,
  66: 43,
  67: 43,
  68: 43,
  69: 44,
  70: 44,
  71: 45,
  72: 45,
  73: 46,
  74: 46,
  75: 47,
  76: 47,
  77: 48,
  78: 48
});

const ROMAN_FRACTIONS = Object.freeze(['0', '1/8', '1/4', '3/8', '1/2', '5/8', '3/4', '7/8']);

const RomanPricingData = Object.freeze({
  ROMAN_BASE_PRICE,
  ROMAN_WIDTH_INCREMENTS,
  ROMAN_HEIGHT_INCREMENTS,
  ROMAN_FRACTIONS
});

if (typeof module !== 'undefined' && module.exports) module.exports = RomanPricingData;
if (typeof window !== 'undefined') window.RomanPricingData = RomanPricingData;
